import React, { useState } from 'react';
import AuthService from '../../services/auth-service';
import PhoneInputComponent from '../../components/common/PhoneInput';
import Button from '../../components/common/Button';

const ResetPasswordRequestForm = ({ onSuccess, msisdn, setMsisdn, userType }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validationMessage, setValidationMessage] = useState(null);

  const handleReset = async (e) => {
    e.preventDefault();

    setError('');
    setValidationMessage(null);
    if (!msisdn) {
      setValidationMessage('Phone number is required');
      return;
    }

    setLoading(true);
    try {
      const { data } = await AuthService.restPassword(msisdn, userType);
      const agent = data?.data?.agent;
      const staff = data?.data?.staff;
      const user = agent ?? staff;
      if (user) onSuccess(user);
      else setError('We could not find a matching user. Please check and try again.');
    } catch (err) {
      setError(err?.response?.data?.message || "We couldn't process your request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="w-full px-4 lg:px-0 mx-auto flex flex-col gap-8">
      <PhoneInputComponent
        labelFor="msisdn"
        labelName="Phone Number"
        placeholder="Enter phone number"
        value={msisdn}
        defaultCountry="GB"
        withCountryCallingCode
        international={true}
        containerStyles={validationMessage ? 'error' : ''}
        validationMessage={validationMessage}
        handlePhoneInputChange={(value) => {
          setMsisdn(value);
          setValidationMessage(null);
          setError('');
        }}
      />

      <div className="w-full flex flex-col gap-3">
        <Button
          type="button"
          onClick={handleReset}
          loading={loading}
          disabled={loading || !msisdn}
          className="w-full"
          size="lg"
        >
          Reset Password
        </Button>
        {error && (
          <div className="flex items-center gap-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <svg className="w-4 h-4 text-red-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <span className="text-sm text-red-800">{error}</span>
          </div>
        )}
      </div>
    </form>
  );
};

export default ResetPasswordRequestForm;